<div class="text-center" id="presentation">
    <div *ngIf="typeSelected == -1" class="leasing-container text-center ui container">
        <h2>Gérer les types de vans</h2>
        <div class="ui stackable three column grid">
            <admin-leasing *ngFor="let leasing of leasings.Value()"
                           [leasing]="leasing"
                           (managed)="manage($event)"
                           (unavailabilitiesCliked)="manageUnavailabilities($event)"
                           class="column"></admin-leasing>
        </div>
    </div>
    <div *ngIf="typeSelected != -1" class="leasing-container text-center ui container">
        <admin-van-edit [type]="typeSelected" (previous)="reset()"></admin-van-edit>
    </div>
    <unavailability #unavailabilityDialog></unavailability>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/leasing/presentation/presentation.html